import { atom } from "recoil";
import { ModalProps } from "@/comn/components/_";

const modalState = atom<ModalProps[]>({
    key: "modalState",
    default: [],
});

export default modalState;
